<template>
  <v-card>
    <v-card-title>
      {{ $t('whitelist.add_title') }}
    </v-card-title>
    <v-card-text style="height: 240px;">
      <v-form ref="form">
        <v-text-field outlined
                      :label="$t('whitelist.username')"
                      v-model="username"
                      :rules="requiredRules"></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit', false)"
             depressed
             large>
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && save()"
             depressed
             large>
        {{ $t('save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {ref} from "@vue/composition-api";
import {ACTION_TYPES} from "@/store/types";

export default {
  name: 'AddAdfsWhiteListDialog',
  setup(props, {root, emit}) {
    const username = ref('');
    const requiredRules = ref([
      value => !!value || root.$t('rules.required')
    ]);

    const save = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/whitelist/create/',
        params: {
          username: username.value,
        }
      })

      if (response.body.success) {
        emit('submit', true);
      }
    }

    return {
      username,
      requiredRules,
      save,
    }
  },
}
</script>
